import { render, staticRenderFns } from "./SelectSum.vue?vue&type=template&id=220d8edb"
import script from "./SelectSum.vue?vue&type=script&lang=js"
export * from "./SelectSum.vue?vue&type=script&lang=js"
import style0 from "./SelectSum.vue?vue&type=style&index=0&id=220d8edb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports